import React from 'react';
import { LinearProgress, Typography } from '@mui/material';

import { ProductsProvider } from 'stores/useProducts';
import { useServerTranslation } from 'hooks/useServerTranslation';
import Product from '../Product/Product';
import { ProductListing } from '../ProductListing';
import useGetProducts from '../../hooks/useGetProducts';
import ProductFilters from '../ProductFilter/ProductFilters';
import ProductsFilterContainer from '../ProductsFilterContainer';

type Props = {
    slug?: string;
    searchValue: string;
};

export function Result(props: Props) {
    return (
        <ProductsProvider>
            <ProvidedResult {...props} />
        </ProductsProvider>
    );
}

export function ProvidedResult(props: Props) {
    const { slug, searchValue } = props;

    const { t } = useServerTranslation();

    const { products, message, loading, loadMore } = useGetProducts({ slug, searchValue });

    if (message) {
        return <>{message}</>;
    }

    return (
        <>
            <Typography style={{ paddingBottom: '50px' }}>
                {t('search.result-title')}
                : &apos;
                {searchValue}
                &apos;
            </Typography>
            <ProductsFilterContainer>
                <ProductFilters searchValue={searchValue} />
                {loading && <LinearProgress sx={{ height: 8 }} />}
                <ProductListing loadMore={loadMore}>
                    {products.map((product, index: number) => (
                        <Product
                            key={index}
                            product={product}
                        />
                    ))}
                </ProductListing>
            </ProductsFilterContainer>
        </>
    );
}
